/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Config from "data/config";
import dayjs from "dayjs";
// import useOrganization from 'hooks/useOrganization'

const DISPLAY_FORMAT = Config.dates.display.time;
const STORAGE_FORMAT = Config.dates.internalFormats.time;

/**
 * 
 * @param {string} timeString
 * @param {string} tz
 * @param {string} format
 */
const formatTime = (timeString, tz, format) => {
    let formattedTime  = "";

    if (timeString) {
        const dateInZone = dayjs.tz(timeString, STORAGE_FORMAT, tz);
        const dateFormat = format && format !== "field.format.none" ? format : DISPLAY_FORMAT;

        formattedTime = dateInZone.format(dateFormat);
    }

    return formattedTime;
};

function getMonthAndDay (dateStr) {
    const date = dayjs(dateStr);
    return {
        day: date.format("DD"),
        month: date.format("MMMM")
    };
}


export { formatTime, getMonthAndDay };
